<template>
  <div>
    <div class="surveyBoxContainer">
      <h5>
        Q{{item.order}}. {{item.question}}(중복가능) {{item.essential == 'Y' ? '' : '(선택)'}} 
      </h5>
      <div class="surveyCheckBoxContain">
        <div v-for="(option, index) in item.options" :key="index" class="flex surveyCheckBox">
          <label :for="checkboxId(index)">{{index + 1}}. {{option.data}} <span class="percent">({{option.percent}}%)</span></label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {STATUS} from '@/data/survey'
import * as validationUtil from '@/utils/validationUtil'

export default {
  name: 'Check',
  props:{
    status: null,
    item: null
  },
  data(){
    return{
      isOngoing: false,
      selected: [] // Option Object List
    }
  },
  mounted(){
    switch(this.status){
      case STATUS.ONGOING:
        this.isOngoing = true
        break
      default:
        this.isOngoing = false
        break
    }

    if(!validationUtil.isEmpty(this.item.answer.data)){
      const selectedOptionIdxList = JSON.parse(this.item.answer.data)
      const options = (this.item.options)

      for(var i = 0; i < options.length; i++){
        for(var j = 0; j < selectedOptionIdxList.length; j++){
          if(options[i].idx == selectedOptionIdxList[j]){
            this.selected.push(options[i])
            break
          }
        }
      }
    }
  },
  watch:{
    selected:{
      handler(selected){
        var temp = []
        for(var i = 0; i < selected.length; i++){
          temp.push(selected[i].idx)
        }
        this.item.answer.data = JSON.stringify(temp)
      }
    }
  },
  methods:{
    checkboxId(index){
      return 'check'+'_'+this.item.order+'_'+index
    }
  }
}
</script>